export interface ManagedUser {
  id: number
  first_name: string | null
  last_name: string | null
  full_name: string
  email: string
  role: string
  role_label: string
  is_active: boolean
  has_agent_record: boolean
  agent_id: number | null
  last_sign_in_at: string | null
  created_at: string
  is_self: boolean
}

// The /admin/users equivalents of the agent-scoped password routes, so the
// shared password menu works for accounts that have no agent record.
export function userPasswordEndpoints(userId: number) {
  return {
    setPassword: `/admin/users/${userId}/set_password`,
    resetLink: `/admin/users/${userId}/password_reset_link`,
    sendResetEmail: `/admin/users/${userId}/send_reset_email`,
    sendWelcomeEmail: `/admin/users/${userId}/send_welcome_email`,
  }
}

export const ROLE_DESCRIPTIONS: Record<string, string> = {
  staff:
    'Day-to-day agent administration: agents, onboarding, documents, commissions, agent tree, messaging. No Reports, Email Activity or Activity Logs, and money is hidden if the organization hides it.',
  administrator:
    'Everything staff can do, plus Reports, Email Activity and Activity Logs. Always sees commission and equity amounts.',
  owner:
    'Full control, including feature flags, data reset and snapshots. Only an owner can create or manage another owner.',
  agent:
    'A regular agent. Available only because this person already has an agent record; their place in the hierarchy is unchanged.',
}
